<template>
  <div>
    <!-- Hero Section -->
    <section class="section-padding bg-gradient-to-br from-white to-gray-50">
      <div class="container-width">
        <div class="grid md:grid-cols-2 gap-12 items-center">
          <div class="space-y-6">
            <h1 class="text-dark-900">
              Enrico Reinsdorf
            </h1>
            <p class="text-2xl font-medium text-primary-500">
              Senior UX Designer
            </p>
            <p class="text-xl text-dark-700 leading-relaxed">
              Mein Schwerpunkt liegt an der Schnittstelle zwischen Fachlichkeit, Technik und Nutzerbedürfnissen – insbesondere in agilen Produktteams.
            </p>
            <div class="flex flex-wrap gap-4 pt-4">
              <NuxtLink
                to="/portfolio"
                class="px-8 py-3 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors font-medium"
              >
                Projekte ansehen
              </NuxtLink>
              <NuxtLink
                to="/contact"
                class="px-8 py-3 border-2 border-primary-500 text-primary-500 rounded-lg hover:bg-primary-50 transition-colors font-medium"
              >
                Kontakt aufnehmen
              </NuxtLink>
              <a
                href="/downloads/Enrico Reinsdorf–UX Portfolio-20260301.pdf"
                download
                class="px-8 py-3 border-2 border-dark-300 text-dark-700 rounded-lg hover:border-dark-500 hover:text-dark-900 transition-colors font-medium"
              >
                Portfolio herunterladen
              </a>
            </div>
          </div>
          <div class="flex justify-center">
            <div class="w-80 h-80 rounded-full overflow-hidden shadow-xl">
              <NuxtImg
                src="/images/enrico-portrait.jpg"
                alt="Enrico Reinsdorf - Senior UX Designer"
                width="320"
                height="320"
                format="webp"
                quality="85"
                loading="eager"
                class="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Kurze Vorstellung -->
    <section class="section-padding bg-white">
      <div class="container-width">
        <div class="max-w-3xl mx-auto text-center space-y-6">
          <h2 class="text-dark-900">Über mich</h2>
          <p class="text-lg text-dark-700">
            Als Senior UX Designer verbinde ich fachliches Verständnis mit technischer Expertise
            und einem tiefen Verständnis für Nutzerbedürfnisse. Mein Ziel ist es, digitale Produkte
            zu schaffen, die nicht nur funktional, sondern auch intuitiv und benutzerfreundlich sind.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
useHead({
  title: 'Enrico Reinsdorf - Senior UX Designer aus Nürnberg | CPUX-F zertifiziert',
  meta: [
    { name: 'description', content: 'Portfolio von Enrico Reinsdorf, Senior UX Designer aus Nürnberg. Expertise in UX Design, Usability Engineering, Design Systems und Product Ownership.' },
    { name: 'keywords', content: 'UX Designer Nürnberg, Senior UX Designer, CPUX-F, User Experience, Design System, Usability Engineering' }
  ]
})
</script>
